"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LandingPage = _interopRequireDefault(require("./screens/LandingPage"));
require("./styles/typography.css");
require("./index.css");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import MockMarty from "./utils/mock-marty";

// new MockMarty(marty2Instance).init(); 

function App(_ref) {
  let {
    isInModal
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LandingPage.default, {
    isInModal: isInModal
  });
}
var _default = exports.default = App;